import {Box} from 'external/material'
import {GroupIcon} from 'resources/icons'

export default function Group({name}) {
  return (
  <Box className="group">
    <Box className="groupIcon">
      <GroupIcon height={24} fill="#809ab3" />
    </Box>
    <Box className="groupName">{name}</Box>
  </Box>
  )
}
